import { render, staticRenderFns } from "./performanceAssignmentComponent.vue?vue&type=template&id=3b707f09&scoped=true&"
import script from "./performanceAssignmentComponent.vue?vue&type=script&lang=js&"
export * from "./performanceAssignmentComponent.vue?vue&type=script&lang=js&"
import style0 from "./performanceAssignmentComponent.vue?vue&type=style&index=0&id=3b707f09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b707f09",
  null
  
)

export default component.exports